var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { class: { noto: _vm.isNotoFontFamily }, attrs: { id: "app" } },
    [
      !_vm.isShowMobileNotification ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _c("MobileNotification", {
        attrs: { show: _vm.isShowMobileNotification }
      }),
      _vm._v(" "),
      _c("MobileSimpleNotification", {
        attrs: { show: _vm.isShowMobileSimpleNotification }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 